import { AuthData, AuthError, RegistrationData } from './auth';
import { EmailVerificationData } from './emailVerification';

export * from './user';
export * from './auth';
export * from './emailVerification';

export interface StoreState {
  /** Authenticaton/authorization data for the currently logged in user */
  authData: AuthData;

  /** Any error that occurred during the authentication process */
  authError: AuthError;

  /** Registration/signup data for the current user */
  registrationData: RegistrationData;

  /** Email verification data for the current user */
  emailVerificationData: EmailVerificationData;

  /** Whether the application has been initialized yet */
  initialized: boolean;

  branding: BrandingData;

  /** Flag to check if translations are available and trigger re-render if necessary */
  languageReady: boolean;

  /** Note slug that will be mapped to display when landing on login page */
  noteFromReferrer?: string;
}

export interface BrandingData {
  logoFile: string;
  primaryColor: string;
  secondaryColor: string;
  actionColor: string;
  headline: string;
  subtext: string;
  /** URL of federated login provider, if one exists */
  externalLoginUrl?: string;
}

export enum InitializationState {
  loading = 'loading',
  authorized = 'authorized',
  unauthorized = 'unauthorized'
}
